import _ from "lodash";
import QueryLanguages from "graphql/queries/QueryLanguages";
import { constantsActive } from "utils/constants/constants";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

const FetchLanguages = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'languages', QueryLanguages, {
			resultPath: [ 'languages' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				const languages = _.filter( result, ( language ) => {
					return language.active === constantsActive.YES;
				} );
				
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( languages );
				}
			},
		})
	}
}

export default FetchLanguages
